import React, { ReactNode } from 'react';
import classNames from 'classnames';

/********
 * NOTE
 ********
 * This is a simple implementation of button groups
 * The button format closely mirrors RCButton
 * commons/src/rc/RCButton/RCButton.tsx
 * Button group example from:
 * https://storybook.reverb.tools/?path=/story/commons-buttongroup--default
 */

interface IButtonGroupButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  selected?: boolean;
  children: ReactNode;
  title?: string;
  id?: string;
  'aria-disabled'?: boolean;
}

interface IProps {
  children: ReactNode;
}

export function ButtonGroupButton({
  onClick,
  children,
  disabled,
  selected,
  title,
  id,
  ...passthroughProps
}: IButtonGroupButtonProps) {

  const buttonClasses = classNames(
    'button-group__button',
    { 'button-group__button--selected': selected },
  );

  return (
    <button
      className={buttonClasses}
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      id={id}
      {...passthroughProps}
    >
      {children}
    </button>
  );
}

export function ButtonGroup({ children }: IProps) {
  return (
    <div className="button-group">
      {children}
    </div>
  );
}
